module.exports = __webpack_public_path__ + "static/media/view_data.34d6747f.svg";